import { panel, surface, border, field, actionButton, zebra } from "../UI/tokens";
import styled from 'styled-components';
import { v } from '../../styles/variables';
import { Button, FormControl, Row, Tooltip } from 'react-bootstrap';

export const TableWrapper = styled.div`
font-family: inherit; border: 0; overflow-x: auto; border-radius: 12px;
`;

export const Table = styled.table`
  width: 100%; max-width: 100%; border-collapse: collapse; font-size: 13px;
  th, td { text-align: left; padding: 10px 14px; white-space: nowrap; vertical-align: middle; }
  td { border-bottom: 1px solid ${border}; }
  tbody tr:nth-child(odd) { background-color: ${surface}; }
  tbody tr:nth-child(even) { ${zebra} }
  tbody tr:last-child td { border-bottom: 0; }
  /* Preserva as cores condicionais da linha, inclusive no hover. */
  tbody tr:hover td { background-image: linear-gradient(rgba(80,110,160,.05), rgba(80,110,160,.05)); }
  input[type='checkbox'] { width: 16px; height: 16px; vertical-align: middle; }
  @media (max-width: 768px) { th, td { padding: 10px 12px; } }

`;

export const HeaderCell = styled.th`
  background: #f4f6fa; color: #243247; border-bottom: 1px solid #dce3ed;
  font-size: 12px; font-weight: 700; letter-spacing: .02em;
  cursor: pointer; user-select: none;

`;

export const HeaderActions = styled.th`
  background: #f4f6fa; color: #243247; border-bottom: 1px solid #dce3ed;
  font-size: 12px; font-weight: 700; letter-spacing: .02em;
  cursor: pointer; user-select: none;

`;

export const LinhaTabela = styled.tr`
    background-color: ${({ isCondicional, corLinha }) => isCondicional ? `${corLinha}!important` : 'transparent'};
`;

export const BodyActions = styled.td`
width: 1%; white-space: nowrap; vertical-align: middle;
`

export const RowActions = styled(Row)`

  display: flex; flex-wrap: nowrap; align-items: center; gap: 6px; margin: 0;
  /* Col md=6 era responsável por dividir os botões em blocos de 50%. */
  & > [class*='col'] { flex: 0 0 auto; width: auto; max-width: none; padding: 0 !important; }

`

export const SDivContainer = styled(Button).attrs({ className: "ui-action-custom" })`
  ${actionButton}
  && { width: auto; min-height: 36px; padding: 7px 11px; white-space: nowrap; }
  span { display: inline; line-height: 1.35; }
  @media (max-width: 768px) { && { min-height: 40px; } }

`;

export const BuscarInput = styled(FormControl)`
  ${field}
  width: min(100%, 360px); margin: 0 0 12px;
  @media (max-width: 768px) { width: 100%; }

`;

export const DivTable = styled.div`
${panel}
 width: 100%; min-width: 0; margin-bottom: 20px;
`;

export const ToolTipButton = styled(Tooltip)`
  display: block;

  @media (max-width: 768px) {
    span {
      display: none; /* Remove o texto do botão no modo móvel */
    }
  }
`;
